import { createTheme } from '@mui/material/styles';
import { color } from './tokens';

const theme = createTheme({
  typography: {
    fontFamily: "'Satoshi', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  palette: {
    primary: {
      main: color.brandPurple,
    },
    text: {
      primary: color.textPrimary,
      secondary: color.textSecondary,
    },
  },
});

export default theme;
